import api from '../../../../../api/client';
import { AUTH } from '../../../../../api/endpoints';
import { handleApiError, handleApiResponse } from '../../../../../api/handlers';
import { authStorage } from '../../../../../utils/authStorage';

//Register
export async function registerUser(payload) {
  try {
    const response = await api.post(AUTH.REGISTER, payload);
    const data = handleApiResponse(response);
    return { response: data };
  } catch (error) {
    const err = new Error(error.response?.data?.message || 'Something went wrong');
    err.response = error.response;
    err.status = error.response?.status || 500;
    throw err; //  must be throw, not return
  }
}
// Login user
export async function loginUser(payload) {
  try {
    const response = await api.post(AUTH.LOGIN, payload);
    const data = handleApiResponse(response);

    // If normal login (not OTP required), store auth data
    if (data.data?.user && data.data?.token && !data.data?.requires_verification) {
      authStorage.setAuth({
        user: data.data.user,
        token: data.data.token,
      });
    }

    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

// Verify OTP
export async function verifyEmailOtp(payload) {
  try {
    const response = await api.post(AUTH.VERIFY_EMAIL_OTP, payload);
    const data = handleApiResponse(response);

    // Store auth data after successful OTP verification
    if (data.data?.user && data.data?.token) {
      authStorage.setAuth({
        user: data.data.user,
        token: data.data.token,
      });
    }

    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

export async function resendEmailOtp(payload) {
  try {
    const response = await api.post(AUTH.RESEND_EMAIL_OTP, payload);
    const data = handleApiResponse(response);
    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

// Verify OTP
export async function verifyMobileOtp(payload) {
  try {
    const response = await api.post(AUTH.VERIFY_MOBILE_OTP, payload);
    const data = handleApiResponse(response);

    // Store auth data after successful OTP verification
    if (data.data?.user && data.data?.token) {
      authStorage.setAuth({
        user: data.data.user,
        token: data.data.token,
      });
    }

    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

// Request OTP for login
export async function requestOtpLogin(payload) {
  try {
    const response = await api.post(AUTH.REQUEST_OTP_LOGIN, payload);
    const data = handleApiResponse(response);
    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

// Forgot Password
export async function forgotPassword(payload) {
  try {
    const response = await api.post(AUTH.FORGOT_PASSWORD, payload);
    const data = handleApiResponse(response);
    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

// Reset Password
export async function resetPassword(payload) {
  try {
    const response = await api.post(AUTH.RESET_PASSWORD, payload);
    const data = handleApiResponse(response);
    return { response: data };
  } catch (error) {
    throw handleApiError(error);
  }
}

// Logout
export async function logoutUser() {
  try {
    const token = authStorage.getToken();
    if (token) {
      await api.post(
        AUTH.LOGOUT,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
    }
  } catch (error) {
    console.error('Logout error:', error);
  } finally {
    authStorage.clearAuth();
  }
}
